// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__31jC8","insightsList":"newBusinessInsightsMenu_insightsList__OMYE3","active":"newBusinessInsightsMenu_active__5iU8S"};